import Insights from 'app/developer-v3/pages/insights';

export default {
  routes: {
    '.': Insights,
  },
};
